import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Carrier } from '../products/productConfiguration';
import { Dropdown } from '@ami/react/core';
import { allExceptIds } from '@ami/react/core';

export class CarriersDropdown extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.instanceOf(Carrier)).isRequired,
    selectedId: PropTypes.string,
    exceptIds: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    isClearable: PropTypes.bool,
  };

  render() {
    const {
      items,
      placeholder,
      selectedId,
      isClearable,
      exceptIds,
      onChange
    } = this.props;

    const filteredItems = exceptIds
      ? allExceptIds(items, exceptIds)
      : items;

    return (
      <Dropdown
        placeholder={placeholder || 'All'}
        items={filteredItems.map((x) => ({
          id: x.id,
          label: x.label,
          imageUrl: x.imageUrl,
        }))}
        selectedId={selectedId}
        onChange={onChange}
        isClearable={isClearable}
      />
    );
  }
}
